let clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
const minLengthDomain = process.env.REACT_APP_ENV == "main" ? 1 : 2;
const parts = window.location.hostname.split(".");
if (parts.length > 0) {
  const subdomains = parts[0].split("-");
  if (subdomains.length > minLengthDomain) {
    const lastSubdomain = subdomains.pop();
    if (lastSubdomain) {
      clientId = process.env["REACT_APP_COGNITO_CLIENT_ID_" + lastSubdomain.toUpperCase()];
    }
  }
}

const awsmobile = {
  aws_cognito_region: process.env.REACT_APP_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_COGNITO_POOL_ID,
  aws_user_pools_web_client_id: clientId,
};

export default awsmobile;